import HolifyaLogoComplete from "@/components/HolifyaLogoComplete"
import TextInputElement from "@/components/input/v1/TextInputElement"
import { Button } from "@/components/ui/button"
import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType } from "@/features/events/types/EventType"
import { FormEvent, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import SessionExpiredDialog from "../../../pages/new-platform/components/SessionExpiredDialog"
import { getRedeemableSortingItems } from "../../../utils/apis/order-service"
import { PHARMACIES_CONFIRMATION_NUMBER } from "../../../utils/Constants"
import { useAuthStore } from "../../../utils/stores/useAuthStore"
import { useUserStore } from "../../../utils/stores/useUserStore"
import { LoadingOverlay } from "../../shared/components/Loaders"
import { useProductRedemption } from "../hooks/useProductRedemption"

const Redeem = () => {

    const navigate = useNavigate()
    const { sendEvent } = useCreateEvent()
    const { auth, logout } = useAuthStore()
    const idToken = auth.idToken
    // const userId = auth.userId
    const { userData } = useUserStore()
    const email = userData.email

    // const { assignNutri } = useAssignNutritionist()
    // const { assignPhysician } = useAssignPhysician()

    const [code, setCode] = useState("")
    // const [codeError, setCodeError] = useState("")

    const { redeemProduct, codeError, isLoading, setCodeError, setIsLoading} = useProductRedemption(code)

    // const [isLoading, setIsLoading] = useState(false)
    const [isGeneralLoading, setIsGeneralLoading] = useState(false)

    const [shouldShowExpirySessionDialog, setShouldShowExpirySessionDialog] = useState(false)

    const onBackToShopClick = async () => {
        await sendEvent({
            event: EventType.BUTTON_CLICK,
            sub_category: "action_button",
            event_metadata: { action: "back_to_shop" },
        });
        window.open("https://www.holifya.com/", "_blank")
        logout(navigate)
    }

    const onSubmitClick = async (e: FormEvent) => {
        e.preventDefault()
        await sendEvent({
            event: EventType.BUTTON_CLICK,
            sub_category: "submit_button",
            event_metadata: { action: "redeem_product", code },
        });
        if (code === PHARMACIES_CONFIRMATION_NUMBER) {
            setIsLoading(true)
            setTimeout(() => {
                navigate("/pharmacies-redeem-swabcode")
                setIsLoading(false)
            }, 1000)
        } else {
            redeemProduct()
        }
    }

    // const callFindOrder = () => {
    //     if (!idToken || !userId) return

    //     setIsLoading(true)

    //     findProduct(
    //         code,
    //         idToken,
    //         async (product) => {
    //             await sendEvent({
    //                 event: EventType.PRODUCT_FOUND,
    //                 sub_category: "redeem",
    //                 event_metadata: { product },
    //             });
    //             const type = product
    //             createProduct(
    //                 userId,
    //                 idToken,
    //                 type,
    //                 async (success) => {
    //                     await sendEvent({
    //                         event: EventType.PRODUCT_SAVED,
    //                         sub_category: "redeem",
    //                         event_metadata: { product },
    //                     });
    //                     if (type === ProductType.MetabolicHook) {
    //                         assignPhysician()
    //                     }
    //                     if (type === ProductType.Nutritionist) {
    //                         assignNutri(
    //                             () => { navigate("/check-purchases") },
    //                             () => { navigate("/check-purchases") },
    //                         )
    //                     } else {
    //                         navigate("/check-purchases")
    //                         setIsLoading(false)
    //                     }
    //                 },
    //                 async (error) => {
    //                     await sendEvent({
    //                         event: EventType.PRODUCT_NOT_SAVED,
    //                         sub_category: "redeem",
    //                         event_metadata: { product },
    //                     });
    //                     console.log(error)
    //                     setIsLoading(false)
    //                 },
    //                 {
    //                     shopify_product: "one-off",
    //                     channel: CreateProductChannel.RedeemCode,
    //                     code: code,
    //                     buyer: null,
    //                     redeemer: null,
    //                 }
    //             )
    //         },
    //         async (error) => {
    //             await sendEvent({
    //                 event: EventType.PRODUCT_NOT_FOUND,
    //                 sub_category: "redeem",
    //             });
    //             setCodeError(error)
    //             setIsLoading(false)
    //         }
    //     )
    // }

    const checkSorting = async () => {
        if (email && idToken) {
            setIsGeneralLoading(true)
            const items = await getRedeemableSortingItems(email, idToken, () => setShouldShowExpirySessionDialog(true));
            if (items.length > 0) {
                navigate("/sorting");
            }
            setIsGeneralLoading(false)
        }
    }

    useEffect(() => {
        const checkSortingInterval = setInterval(() => {
            checkSorting();
        }, 1 * 60 * 1000);

        checkSorting();

        return () => clearInterval(checkSortingInterval);
    }, [email, idToken]);

    useEffect(() => {
        void sendEvent({
            event: EventType.PAGE_VIEW,
            sub_category: "redeem_page",
        })
    }, [])

    // ********************************************************************************

    return (
        <div className="w-full h-screen flex flex-col items-center">
            <div className="w-full h-full flex flex-col items-center justify-end md:justify-center">
                <div className="w-[90%] h-[90%] flex flex-col items-center justify-between md:w-[435px] md:h-[70%]">
                    <div className="flex flex-col items-center space-y-[10px]">
                        <HolifyaLogoComplete />
                        <div className="font-normal text-[16px] leading-[24px] text-center">
                            Non esistono ancora acquisti associati.
                        </div>
                    </div>
                    <div className="flex flex-col items-center space-y-[10px]">
                        <div className="font-bold text-[25px] leading-[33px]">
                            🔓 Riscatta o Acquista
                        </div>
                        <div className="font-normal text-[16px] leading-[24px] text-center">
                            Se hai ricevuto un Codice Riscatto puoi riscattare il prodotto associato inserendolo qui sotto.
                        </div>
                        <div className="w-[30px] h-[1px] bg-black mt-[10px]" />
                        <div className="font-normal text-[16px] leading-[24px] text-center">
                            In alternativa, per riscattare e gestire acquisti con questo account assicurati di utilizzare la mail <span className="font-bold text-holifya-blue">{email}</span> al momento dell'acquisto.
                        </div>
                    </div>
                    <form
                        className="w-full md:px-[30px]"
                        onSubmit={onSubmitClick}
                    >
                        <div className="h-[85px]">
                            <TextInputElement
                                label="Codice riscatto"
                                placeholder="123456"
                                errorText={codeError}
                                inputValue={code}
                                onChange={(e) => {
                                    setCodeError("")
                                    setCode(e.target.value)
                                }}
                            />
                        </div>
                        <div className="space-y-[20px]">
                            <Button size={'form'} disabled={code.length < 6}>
                                Conferma codice
                            </Button>
                            <Button variant={'white'} size={'form'} onClick={onBackToShopClick}>
                                Torna allo Shop
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
            {/* TODO [TM]: add the form box */}
            {/* <FormBox
                description={"Non esistono ancora acquisti associati"}
                formContent={
                    <div className="flex flex-col items-center w-[90%]">
                        <div className="flex flex-col items-center">
                            <div className="font-bold text-[25px] leading-[33px] mb-[10px]">
                                🔓 Riscatta o Acquista
                            </div>
                            <div className="font-normal text-[16px] leading-[24px] text-center mt-[10px]">
                                Se hai ricevuto un Codice Riscatto puoi riscattare il prodotto associato inserendolo qui sotto.
                            </div>
                            <div className="w-[30px] h-[1px] bg-black mt-[10px]" />
                            <div className="font-normal text-[16px] leading-[24px] text-center mt-[10px]">
                                In alternativa, per riscattare e gestire acquisti con questo account assicurati di utilizzare la mail <span className="font-bold text-holifya-blue">{email}</span> al momento dell'acquisto.
                            </div>
                        </div>
                        <TextInputElement
                            label="Codice riscatto"
                            placeholder="123456"
                            errorText={codeError}
                            inputValue={code}
                            onChange={(e) => {
                                setCodeError("")
                                setCode(e.target.value)
                            }}
                        />
                        <Button size={'form'} disabled={code.length < 6}>
                            Conferma codice
                        </Button>
                    </div>
                }
                onSubmit={onSubmitClick}
                actionButton={
                    <div className="w-full h-[50px]">
                        <WhiteButtonBlackBorder
                            text="Torna allo Shop"
                            onClick={onBackToShopClick}
                            uppercase={false}
                        />
                    </div>
                } /> */}
            {
                shouldShowExpirySessionDialog && <SessionExpiredDialog />
            }
            {
                (isGeneralLoading || isLoading) && <LoadingOverlay />
            }
        </div>
    )
}

export default Redeem
